module.exports = __webpack_public_path__ + "img/Jean-Michel-Veyssy.e1aaf6e2.jpg";